import gql from 'graphql-tag';

export const CREATE_JOBS_CREATIVES_CREATE_JOB = gql`
  mutation CreateJobsCreativesCreateJob(
    $articleGroupId: ID!
    $creativesParams: JobsCreativesCreateJobsCreativeInput!
    $articlesParams: [JobsCreativesCreateJobsArticleInput!]!
  ) {
    createJobsCreativesCreateJob(
      articleGroupId: $articleGroupId
      creativesParams: $creativesParams
      articlesParams: $articlesParams
    ) {
      jobsCreativesCreateJob {
        id
      }
      errors
    }
  }
`;
